// src/pages/beta-community/components/VideoSection.jsx
import React from 'react';

const VideoSection = () => {
  return (
    <section id="demo" className="section video-section">
      <div className="container">
        <h2 className="section-title">Comprendre ARTKIV en quelques minutes</h2>
        
        <div className="video-container">
          <div className="video-placeholder">
            <div className="play-icon">▶</div>
            <p>Démo produit à venir : collection, fiches œuvres, rapports et parcours professionnels</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;